import { api } from "../../services";

const kanban_columns = {
  // namespaced:true,
  state: {
    data: [],
    metrics:
    {
      open: { count:0, total_price:0 },
      expired: { count:0, total_price:0 },
      loss: { count:0, total_price:0 },
      gain: { count:0, total_price:0 }
    },
    search:"",
    fields_search: {
      pipeline_id: 0,
      channel_id: 0,
      department_id: 0,
      user_id: 0,
      stage_key: 0,
      start_date: null,
      final_date: null,
      lead_name: "",
      lead_phone: "",
    },
    model_fields_search: {
      pipeline_id: null,
      channel_id: null,
      department_id: null,
      user_id: null,
      stage_key: 0,
      start_date: null,
      final_date: null,
      lead_name: "",
      lead_phone: "",
    },
    modals: {
      filter: false,
      new_column: false,
      edit_column: false,
      new_task_trigger: false,
      initial_filter: false,
      confirm_delete: false,
    },
    task_trigger: {
      pipeline_infos: {
        id: null,
        name: null,
        color: null,
      },
      data: [],
    },
    model_task_trigger: {
      pipeline_infos: {
        id: null,
        name: null,
        color: null,
      }
    },
    board_view_enabled: false,
    new_column: {
      name: null,
      color: null,
      position: null,
      channel_id: null,
      department_id: null,
    },
    model_new_column: {
      name: null,
      color: null,
      position: null,
      channel_id: null,
      department_id: null,
    },
    edit_column: {
      id: null,
      name: null,
      color: null,
      position: null,
      channel_id: null,
      department_id: null,
    },
    model_edit_column: {
      name: null,
      color: null,
      position: null,
      channel_id: null,
      department_id: null,
    },
    departments_available: [],
    operators_available: [],
    filter_applied: false
  },
  mutations: {
    SET_COLUMNS_VALUE(state, payload) {
      state.data = payload.data;
      if(payload.metrics){
        state.metrics = payload.metrics;
      }
    }
  },
  getters: {
    filterDepartmentsAvailable: (state) => (key, value) => {
      if (state.departments_available !== undefined) {
        return state.departments_available.filter(item => {
          return item[`${key}`] === value;
        });
      }
      return [];
    },
    filterOperatorsAvailable: (state) => (key, value) => {
      if (state.operators_available !== undefined) {
        return state.operators_available.filter(item => {
          return item[`${key}`] === value;
        });
      }
      return [];
    },
    getKanbanCardsFilter: (state, context) => (cards) => {
      return cards.length >= 1 && state.search.trim() !== ""
        ? cards.filter(card => {
          const isSearchCardName = card.name ? card.name.toLowerCase().includes(state.search.trim().toLowerCase()) : false

          return isSearchCardName;
        })
        : cards;
      // if(cards.length >= 1) {
      //   if(state.search.trim() !== "") {
      //     return cards.filter(card => {
      //       const isSearchCardName = card.name ? card.name.toLowerCase().includes(state.search.trim().toLowerCase()) : false

      //       return isSearchCardName;
      //     });
      //   } else {
      //     return cards;
      //   }
      // } else {
      //   return [];
      // }
    },
  },
  actions: {
    async getAllColumns(context, fields_search) {
      await api.get(`kanban/columns`, {
        params: fields_search
      }).then(response => {
          context.commit("SET_COLUMNS_VALUE", response.data);
        });
    },
    async saveColumn(context, { method, ...column }) {
      switch (method) {
        case "edit":
          //send edit column request
          await api.put(`/kanban/columns/${column.id}`, {
            ...column
          }).then(() => {
            context.rootState.kanban_columns.modals.edit_column = false
            context.rootState.kanban_columns.edit_column = context.rootState.kanban_columns.model_edit_column;
            context.dispatch("getAllColumns", {
              channel_id: column.channel_id,
              department_id: column.department_id
            })
          });

          break;

        case "add":
          await api.post("/kanban/columns", {
            ...column
          })
            .then(() => {
              context.rootState.kanban_columns.modals.new_column = false;
              context.rootState.kanban_columns.new_column = context.rootState.kanban_columns.model_new_column;
              context.dispatch("getAllColumns", {
                channel_id: column.channel_id,
                department_id: column.department_id
              })
            });
          break;
      }
    },
    deleteColumn(context, { column }) {
      api.delete(`/kanban/columns/${column.id}`)
        .then(() => context.dispatch("getAllColumns", {
          channel_id: column.channel_id,
          department_id: column.department_id
        }));
    }
  }
};
export default kanban_columns;
